import React from 'react';

import { Modal } from '@companycam/slab-web';
import PromoModalVideoPlayer from 'components/shared/PromoModalVideoPlayer';

export type WatchDemoModalProps = {
  onRequestClose: () => void;
  youtubeSrc: string;
};

const WatchDemoModal = ({
  onRequestClose,
  youtubeSrc,
}: WatchDemoModalProps) => {
  return (
    <Modal
      isOpen
      title=""
      onClose={onRequestClose}
      headerComponent={null}
      footerComponent={null}
    >
      <PromoModalVideoPlayer youtubeSrc={youtubeSrc} />
    </Modal>
  );
};

export default WatchDemoModal;
